/*
 * Copyright © HatioLab Inc. All rights reserved.
 *
 * 데이터 필드값이 JSON 문자열로 전달될 수 있어(예: CRANEPOSITION, MULTICARRIERS)
 * 객체/배열로 변환하기 위한 헬퍼.
 */

/**
 * 값이 JSON 문자열이면 파싱해서 반환. 객체/배열 등 비문자열은 그대로 반환.
 * 파싱 실패 시 undefined.
 */
export function parseIfJsonString(value: any): any {
  if (typeof value !== 'string') return value
  try {
    return JSON.parse(value)
  } catch {
    return undefined
  }
}
